import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NewPasswordModule } from '../../../projects/kiene-core/src/lib/components/new-password/new-password.module';
import { BenutzerModule } from '../../../projects/kiene-core/src/lib/components/stammdaten/benutzer/benutzer.module';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { ArticleScanAutocompleteModule } from '../components/article-scan-autocomplete/article-scan-autocomplete.module';
import { KieneClientAutocompleteModule } from '../components/client-autocomplete/client-autocomlete.module';
import { ComponentsModule } from '../components/components.module';
import { DeleteButtonModule } from '../components/delete-button/delete-button.module';
import { HitPinAnzeigenDialogComponent } from '../components/hit-pin-anzeigen-dialog/hit-pin-anzeigen-dialog.component';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { SelectorModule } from '../components/selector/selector.module';
import { VerkaufspreisSelectorModule } from '../components/verkaufspreis-selector/verkaufspreis-selector.module';
import { KieneDirectivesModule } from '../directives/kiene-directives.module';
import { GruppenverwaltungModule } from '../documents/gruppenverwaltung/gruppenverwaltung.module';

import { AdministrationRoutingModule } from './administration-routing.module';
import { AdministrationComponent } from './administration.component';
import { BenutzerBenutzerrechtDialogComponent } from './benutzer-benutzerrechte/benutzer-benutzerrecht-dialog/benutzer-benutzerrecht-dialog.component';
import { BenutzerBenutzerrechteComponent } from './benutzer-benutzerrechte/benutzer-benutzerrechte.component';
import { BetriebsartPreiseUndRabattDialogComponent } from './betriebsarten/betriebsart-preise-und-rabatt-dialog/betriebsart-preise-und-rabatt-dialog.component';
import { BetriebsartenTierartenDialogComponent } from './betriebsarten/betriebsarten-tierarten-dialog/betriebsarten-tierarten-dialog.component';
import { ProduktionsabschnitteComponent } from './betriebsarten/produktionsabschnitte/produktionsabschnitte.component';
import { BetriebstypDetailsDialogComponent } from './betriebstypen/betriebstyp-details-dialog/betriebstyp-details-dialog.component';
import { BetriebstypenComponent } from './betriebstypen/betriebstypen.component';
import { ChangeCurrentClientService } from './client/change-current-client/change-current-client.service';
import { ClientService } from './client/client.service';
import { CompanyGroupArticleDialogComponent } from './company-group/company-group-article-dialog/company-group-article-dialog.component';
import { CompanyGroupService } from './company-group/company-group.service';
import { PreislistePdfDownloadDialogComponent } from './company-group/preisliste-pdf-download-dialog/preisliste-pdf-download-dialog.component';
import { InventurActiceNoticeDialogComponent } from './inventur-verwaltung/inventur-actice-notice-dialog/inventur-actice-notice-dialog.component';
import { InventurCreateDialogComponent } from './inventur-verwaltung/inventur-create-dialog/inventur-create-dialog.component';
import { InventurDeleteDialogComponent } from './inventur-verwaltung/inventur-delete-dialog/inventur-delete-dialog.component';
import { InventurEditDialogComponent } from './inventur-verwaltung/inventur-edit-dialog/inventur-edit-dialog.component';
import { InventurVerwaltungComponent } from './inventur-verwaltung/inventur-verwaltung.component';
import { TextBausteinComponent } from './text-baustein/text-baustein.component';
import { TextbausteinGeneralDialogComponent } from './text-baustein/textbaustein-general-dialog/textbaustein-general-dialog.component';
import { UserDetailsComponent } from './user/user-details/user-details.component';
import { UserComponent } from './user/user.component';
import { UserService } from './user/user.service';
import { UserroleComponent } from './userrole/userrole.component';
import { UserroleService } from './userrole/userrole.service';
import { AddVetGroupDialogComponent } from './vet-group/add-vet-group-dialog/add-vet-group-dialog.component';
import { UpdateVetGroupDialogComponent } from './vet-group/update-vet-group-dialog/update-vet-group-dialog.component';
import { VetGroupDetailsDialogComponent } from './vet-group/vet-group-details-dialog/vet-group-details-dialog.component';
import { VetGroupComponent } from './vet-group/vet-group.component';
import { VetDetailsDialogComponent } from './vet/vet-details-dialog/vet-details-dialog.component';
import { VetVetGroupDetailsDialogComponent } from './vet/vet-vet-group-details-dialog/vet-vet-group-details-dialog.component';
import { VetComponent } from './vet/vet.component';
import { VetService } from './vet/vet.service';
import { CombinedBenutzerTierarztDialogComponent } from './vet/combined-benutzer-tierarzt-dialog/combined-benutzer-tierarzt-dialog.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        AdministrationComponent,
        UserComponent,
        UserDetailsComponent,
        UserroleComponent,
        VetComponent,
        VetDetailsDialogComponent,
        VetVetGroupDetailsDialogComponent,
        VetGroupComponent,
        InventurVerwaltungComponent,
        InventurCreateDialogComponent,
        InventurEditDialogComponent,
        InventurDeleteDialogComponent,
        InventurActiceNoticeDialogComponent,
        BetriebstypenComponent,
        BetriebstypDetailsDialogComponent,
        PreislistePdfDownloadDialogComponent,
        CompanyGroupArticleDialogComponent,
        HitPinAnzeigenDialogComponent,
        UpdateVetGroupDialogComponent,
        AddVetGroupDialogComponent,
        ProduktionsabschnitteComponent,
        BetriebsartPreiseUndRabattDialogComponent,
        BetriebsartenTierartenDialogComponent,
        VetGroupDetailsDialogComponent,
        TextBausteinComponent,
        TextbausteinGeneralDialogComponent,
        CombinedBenutzerTierarztDialogComponent,
        BenutzerBenutzerrechteComponent,
        BenutzerBenutzerrechtDialogComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatPaginatorModule,
        KieneAutocompleteModule,
        KieneTableModule,
        AdministrationRoutingModule,
        GruppenverwaltungModule,
        DeleteButtonModule,
        SelectorModule,
        ArticleScanAutocompleteModule,
        KieneClientAutocompleteModule,
        VerkaufspreisSelectorModule,
        ComponentsModule,
        MatTableModule,
        DragDropModule,
        NewPasswordModule,
        BenutzerModule,
        DirectivesModule,
        MatGridListModule,
        KieneDirectivesModule,
        MatDividerModule,
        KieneDirectivesModule,
        ClipboardModule,
        MatTooltipModule,
        KieneDirectivesModule,
        ClipboardModule,
    ],
    providers: [
        UserService,
        UserroleService,
        VetService,
        ClientService,
        CompanyGroupService,
        ChangeCurrentClientService,
    ],
})
export class AdministrationModule {}
